import React from 'react';

import {observer} from 'mobx-react';
import {ScoresPlaceholder} from "../../../core/components/scores-placeholders/placeholder/scores.placeholder";
import styles from "../styles/all-scores-widget.module.scss";
import classnames from "classnames";

export const AllScoresWidgetPlaceholder = observer(({
                                                      includeFeaturedGamesWidget,
                                                      isSmallView,
                                                      controller,
                                                      className
                                                    }) => {
  return (
    <>
      <div className={classnames(styles.filter_bar_placeholder_container)}>
        <div className={classnames(styles.date_picker)}/>
        <div className={classnames(styles.filter_bar)}/>
      </div>
      {
        isSmallView ? <div className={classnames(styles.external_ad_placeholder)}/> : null
      }
      {
        includeFeaturedGamesWidget ? <div
          className={classnames(styles.featured_games_placeholder, {[styles.small_view]: isSmallView || controller?.device.isSmallView}, className)}/> : null
      }
      <ScoresPlaceholder shouldHideHeader/>
    </>
  )
});
